export const getCalculatedPriceWithoutVAT = (
  fullPrice: number,
  taxAmount: number,
): string => {
  if (!taxAmount) return fullPrice.toFixed(2)

  return ((fullPrice * 100) / (100 + taxAmount)).toFixed(2)
}
